export function checkMobileBrowser() {
    return window.navigator.userAgent.toLowerCase().includes('mobi');
}

export const getScrollRem = () => window.scrollY / parseFloat(getComputedStyle(document.documentElement).fontSize);
